if (!customElements.get('application-modal')) {
    customElements.define(
        'application-modal',
        class ApplicationModal extends ModalDialog {
            constructor() {
                super();
                this.modalContent = this.querySelector('[id^="CustomModalSection-"]');
            }

            hide(preventFocus = false) {
                //this.modalContent.innerHTML = '';
                if (preventFocus) this.openedBy = null;
                super.hide();
            }

            show(opener) {
                opener.setAttribute('aria-disabled', true);
                opener.classList.add('loading');
                opener.querySelector('.loading__spinner').classList.remove('hidden');

                if (window.ProductModel) window.ProductModel.loadShopifyXR();
                super.show(opener);

                opener.removeAttribute('aria-disabled');
                opener.classList.remove('loading');
                opener.querySelector('.loading__spinner').classList.add('hidden');
            }

            setInnerHTML(element, html) {
                element.innerHTML = html;

                // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
                element.querySelectorAll('script').forEach((oldScriptTag) => {
                    const newScriptTag = document.createElement('script');
                    Array.from(oldScriptTag.attributes).forEach((attribute) => {
                        newScriptTag.setAttribute(attribute.name, attribute.value);
                    });
                    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
                });
            }
        }
    );
}
